import React, { useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { StyleSheetManager } from 'styled-components';
import { useSelector } from 'react-redux';

// Libs
import ModalManager from 'libs/ModalManager';
import Modal from 'components/common/Modal';

/* WithTheme Component =================== */
const WithTheme = ({ children }) => {
	const {webConfig} = useSelector(state => state.core);

	const { themeObject } = useMemo(() => {
		const theme = createTheme({
			direction: webConfig.dir,
			typography: {
			},
			palette: {
				color: {
				},
				background: {
				},
			},
		});

		return { themeObject: theme };
	}, []);

	return (
		<StyleSheetManager>
			<ThemeProvider theme={themeObject}>
				<Modal ref={ModalManager.modal} />
				<CssBaseline />
				{children}
			</ThemeProvider>
		</StyleSheetManager>
	);
};

// Export default
export default WithTheme;
